export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00742.a3f7826b.png";